import { useCallback, useMemo } from 'react';

import { Feature } from '@ts-core/utils/features';

import { useProfessorAuth } from 'modules/auth/hooks';

export default function useAcademyAuthUtils() {
  const { user } = useProfessorAuth();

  const academyFeatures = useMemo(() => user?.academy?.features || [], [user]);

  const academyHasFeature = useCallback(
    (feature) => {
      return academyFeatures?.includes(feature);
    },
    [academyFeatures]
  );

  const academyHasFeatures = useCallback(
    (requiredFeatures) => {
      if (!requiredFeatures) {
        return true;
      }
      for (const feature of requiredFeatures) {
        if (!academyFeatures?.includes(feature)) {
          return false;
        }
      }
      return true;
    },
    [academyFeatures]
  );

  return {
    Feature,
    academyHasFeature,
    academyHasFeatures,
  };
}
